/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createTo } from '../../factoriesAny.js';
export var toDependencies = {
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createTo: createTo
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesTo.generated.js
// module id = 1671
// module chunks = 0